import { useQuery } from '@apollo/client'
import { GET_ALL_TEMPLATES } from '../backbone/queries'
import { Block } from '../backbone/types'

export const useLoadTemplateBlocks = () => {
  return useQuery<{ allTemplates: Block[] }>(GET_ALL_TEMPLATES)
}
